/**
 * localStorage persistence for per-table DataTable preferences.
 *
 * Entries are keyed `bliks:datatable:<tableId>:<segment>` (the existing
 * `bliks:`-prefixed key convention) so each table remembers its own
 * preference independently across reloads, navigation and logout/login
 * (per-browser/per-device).
 */ export function createNamespacedStorage(segment, validate) {
    const storageKey = (tableId)=>`bliks:datatable:${tableId}:${segment}`;
    return {
        storageKey,
        read (tableId) {
            if (!tableId) return null;
            try {
                const raw = localStorage.getItem(storageKey(tableId));
                if (!raw) return null;
                return validate(JSON.parse(raw));
            } catch  {
                return null;
            }
        },
        write (tableId, value) {
            if (!tableId) return;
            try {
                localStorage.setItem(storageKey(tableId), JSON.stringify(value));
            } catch  {
            // Ignore — a failed persist must not break the interaction.
            }
        }
    };
}

//# sourceMappingURL=namespaced-storage.js.map